<template>
  <div>
    <MainHeader />

    <Overview v-if="init && (profile)" />

    <Leader v-if="init && (!profile)" />

    <Teaser v-if="init && (!profile)" />

    <Accreditation v-if="init && (!profile)" />

    <Footer />
  </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import SubHeader from '@/components/factsheet/SubHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  import Overview from '@/components/home/user/Overview.vue'

  import Leader from '@/components/home/Leader.vue'
  import Teaser from '@/components/home/Teaser.vue'
  import Accreditation from '@/components/home/Accreditation.vue'

  export default {
    name: 'home',
    components: {
      Leader, Teaser, Accreditation, MainHeader, Footer, Overview
    },
    computed: {
        profile() {
            return this.$store.state.profile
        },
        init() {
          return this.$store.state.init
        }
    }
  }
</script>

<style scoped>
    div.container {
        background-color:#eee;
    }


 
</style>
